import { createContext } from 'react'

export type HttpStatusRef = {
  code: number
}

export type SsrContextType = {
  isMobileUA?: boolean
  processEnv?: string
  /** Set during SSR when a page reports a non-200 status (e.g. 404). */
  httpStatusRef?: HttpStatusRef
}

export const SsrContext = createContext<SsrContextType>({})
